import {
	AfterViewInit,
	Component,
	OnDestroy,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomModalService } from '@lmc-app/services/modal/custom-modal.service';
import { ModalNames } from '@lmc-app/services/modal/custom-modal-options';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { User } from '@lmc-app/shared/interface/user.interface';
import {
	MatFormField,
	MatLabel,
	MatInput,
	MatError,
} from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-insurance-trans-cancellation',
	templateUrl: './insurance-trans-cancellation.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./insurance-trans-cancellation.component.scss'],
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		NgIf,
		MatError,
		MatButton,
	],
})
export class InsuranceTransCancellationComponent
	implements OnInit, OnDestroy, AfterViewInit
{
	loan_number = new FormControl('', Validators.required);
	displayRes: any;
	modalDataSubscription: Subscription;
	userName: any;
	btnSpinner = false;
	btnShowText = true;
	private readonly _onDestroy = new Subject<void>();

	constructor(
		private apiService: LegacyApiService,
		private customModalService: CustomModalService,
		private store: Store<State>
	) {}

	async ngAfterViewInit(): Promise<void> {
		this.modalDataSubscription =
			this.customModalService.modelClosedObservable.subscribe(
				(closedOptions) => {
					this.handleModalClosed(closedOptions);
				}
			);
	}

	ngOnInit(): void {
		this.displayRes = '';

		// Subscribe to user from NgRx store
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.userName = user.full_name;
				}
			});
	}

	async handleModalClosed(closedOptions = {}) {
		const { modalName, result, options } = closedOptions as any;
		if (
			modalName === ModalNames.INSURANCE_TRANSACTION_CANCELLATION &&
			result === 'YES' &&
			(typeof options !== undefined || options !== '')
		) {
			console.log('PROCEED CANCELLATION!');
			this.cancelInsuranceTransactions(options, this.userName);
		}
	}

	openModal(
		modalName,
		headerTitle: string = '',
		bodyText: string = '',
		buttons: Array<string> = [''],
		options = ''
	) {
		this.customModalService.openModal({
			modalName,
			activateModal: true,
			headerTitle,
			bodyText,
			buttons,
			options,
		});
	}

	getFileName() {
		this.apiService
			.checkLoanNumberName(this.loan_number.value)
			.subscribe((res: any) => {
				if (res?.status && res?.data?.length > 0) {
					this.openModal(
						ModalNames.INSURANCE_TRANSACTION_CANCELLATION,
						`${res?.data?.[0]?.firstname1} ${res?.data?.[0]?.lastname1}`,
						`Do you want to cancel the insurance transactions?`,
						['YES', 'NO'],
						`${res?.data?.[0]?.acctrefno}`
					);
				} else {
					this.displayRes = `Loan number not found!`;
				}
			});
	}

	cancelInsuranceTransactions(acctrefno, reversed_by) {
		this.displayRes = '';
		this.loadResult();
		this.apiService
			.cancelInsuranceTransactions(acctrefno, reversed_by)
			.subscribe((res: any) => {
				this.displayRes = res?.message;
				this.resultCompleted();
			});
	}

	loadResult() {
		this.btnSpinner = true;
		this.btnShowText = false;
	}

	resultCompleted() {
		this.btnSpinner = false;
		this.btnShowText = true;
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
		this.modalDataSubscription?.unsubscribe();
	}
}
